import { CellContext } from '@tanstack/react-table';
import i18next from 'i18next';
import { FC } from 'react';

import { StockData } from '@/api/rest/resources/types/stocks';
import { NO_DATA_PLACEHOLDER } from '@/config/constants';
import { useCurrency } from '@/hooks/useCurrency';
import { isNullish } from '@/utils/booleans';

export const SellerNameCell: FC<CellContext<StockData, unknown>> = ({ getValue }) => {
  const value = getValue() as string;
  return <span>{isNullish(value) || value === '' ? NO_DATA_PLACEHOLDER : value}</span>;
};

export const BuyerNameCell: FC<CellContext<StockData, unknown>> = ({ getValue }) => {
  const value = getValue() as string;
  return <span>{isNullish(value) || value === '' ? NO_DATA_PLACEHOLDER : value}</span>;
};

export const StockIssuanceDateCell: FC<CellContext<StockData, unknown>> = ({ getValue }) => {
  const date = getValue() as string | null;
  return <span>{date ? new Date(date).toLocaleDateString(i18next.language) : NO_DATA_PLACEHOLDER}</span>;
};

export const StockSaleDateCell: FC<CellContext<StockData, unknown>> = ({ getValue }) => {
  const date = getValue() as string | null;
  return <span>{date ? new Date(date).toLocaleDateString(i18next.language) : NO_DATA_PLACEHOLDER}</span>;
};

export const CurrencyCell: FC<CellContext<StockData, unknown>> = ({ getValue }) => {
  const { convertAndFormat } = useCurrency();
  const value = getValue() as number;
  return <span>{isNullish(value) ? NO_DATA_PLACEHOLDER : convertAndFormat(value)}</span>;
};

export const StockSerialNumberCell: FC<CellContext<StockData, unknown>> = ({ getValue }) => {
  const value = getValue() as string;
  return <span>{isNullish(value) || value === '' ? NO_DATA_PLACEHOLDER : value}</span>;
};
